import { useEffect } from "react";

function cssEscape(value) {
  if (window.CSS?.escape) return window.CSS.escape(value);
  return String(value || "").replace(/[^a-zA-Z0-9_-]/g, "\\$&");
}

export default function useVestaFocusHighlight(location) {
  useEffect(() => {
    const params = new URLSearchParams(location.search || "");
    const focusId = params.get("focusId");
    if (!focusId) return undefined;

    let attempts = 0;
    let stopped = false;
    let timer = null;
    let cleanupGoldListeners = null;

    const clearPrevious = () => {
      document.querySelectorAll(".vesta_focus_flash, .vesta_focus_gold").forEach((node) => {
        node.classList.remove("vesta_focus_flash", "vesta_focus_gold");
      });
    };

    const tryFocus = () => {
      if (stopped) return;
      const selector = `[data-vesta-focus-id="${cssEscape(focusId)}"]`;
      const target = document.querySelector(selector);
      if (!target) {
        attempts += 1;
        if (attempts < 90) timer = window.setTimeout(tryFocus, 80);
        return;
      }

      clearPrevious();
      const scrollContainer = target.closest(".management_table_shell");
      if (scrollContainer) {
        const targetRect = target.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        const targetTop = scrollContainer.scrollTop
          + (targetRect.top - containerRect.top)
          - ((scrollContainer.clientHeight - targetRect.height) / 2);
        scrollContainer.scrollTo({
          top: Math.max(0, targetTop),
          left: scrollContainer.scrollLeft,
          behavior: "smooth",
        });
      } else {
        target.scrollIntoView({ block: "center", inline: "nearest", behavior: "smooth" });
      }
      window.setTimeout(() => {
        target.classList.add("vesta_focus_flash");
        window.setTimeout(() => {
          if (stopped) return;
          target.classList.remove("vesta_focus_flash");
          target.classList.add("vesta_focus_gold");

          const clearGoldSelection = () => {
            clearPrevious();
            if (cleanupGoldListeners) cleanupGoldListeners();
          };
          document.addEventListener("pointerdown", clearGoldSelection, { once: true, capture: true });
          document.addEventListener("keydown", clearGoldSelection, { once: true, capture: true });
          cleanupGoldListeners = () => {
            document.removeEventListener("pointerdown", clearGoldSelection, { capture: true });
            document.removeEventListener("keydown", clearGoldSelection, { capture: true });
            cleanupGoldListeners = null;
          };
        }, 2100);
      }, 260);
    };

    timer = window.setTimeout(tryFocus, 120);
    return () => {
      stopped = true;
      if (timer) window.clearTimeout(timer);
      if (cleanupGoldListeners) cleanupGoldListeners();
    };
  }, [location.pathname, location.search]);
}
